module.exports = __webpack_public_path__ + "static/media/meditacoes.ccabf619.png";